import { Injectable } from '@angular/core';

import { ConsultationDataProvider } from '../consultation-data/consultation-data';
import { ConsultationDisplayProvider } from '../consultation-display/consultation-display';
import { ConstantsProvider } from '../constants/constants';

import { DataProvider } from '../../providers/data/data';

/*
  Generated class for the ConsultationDataParserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConsultationDataParserProvider {

   /** ----- Constructor ----- **/

   constructor(
      private consultationData: ConsultationDataProvider,
      private data: DataProvider,
      private consultationDisplay: ConsultationDisplayProvider,
      private constants: ConstantsProvider) { }


   /** ----- API to Display ----- **/

   convertSymptoms(inData) {

      // save selected consultation
      this.consultationData.consultation = inData;

      // symptoms
      if (inData['con_symptoms'] != null && inData['con_symptoms'] != '') {
         let obj = JSON.parse(inData['con_symptoms']);
         if (obj != null) {
            let symptoms = (obj['data'].length > 0) ? JSON.parse(obj['data']) : [];
            let remarks = (obj['remark'].length > 0) ? JSON.parse(obj['remark']) : [];

            for (let i = 0; i < symptoms.length; i++) {
               // find symptom obj by id and add to list
               let symptomObj = this.consultationDisplay.findSymptom(symptoms[i]['id']);
               if (symptomObj != null) {
                  this.consultationData.chosenSymptoms.push(symptomObj);
                  this.consultationData.chosenSymptomsRemark.push(remarks[i]);
               }
            }
         }
      }

      // remark
      this.consultationData.consRemark = (inData['con_explain'] != null && inData['con_explain'] != '') ? inData['con_explain'] : '';
      this.consultationData.signCons = (inData['con_con_phy'] != null && inData['con_con_phy'] != '') ? inData['con_con_phy'] : -1;
      this.consultationData.signDisp = (inData['con_disp_phy'] != null && inData['con_disp_phy'] != '') ? inData['con_disp_phy'] : -1;
      this.consultationData.signAcus = (inData['con_acu_phy'] != null && inData['con_acu_phy'] != '') ? inData['con_acu_phy'] : -1;

      this.consultationData.slBegin = (inData['con_sl_begin'] != null) ? this.getApiDate(new Date(inData['con_sl_begin'])) : null;
      this.consultationData.slEnd = (inData['con_sl_end'] != null) ? this.getApiDate(new Date(inData['con_sl_end'])) : null;

   }


   convertDispensaries(inData) {

      // save selected dispensary
      this.consultationData.dispensary = (inData != null) ? inData : [];

      // loop every dispensary
      for (let i = 0; i < this.consultationData.dispensary.length; i++) {
         // add dispensary item to list
         this.consultationData.dispBoardActive.push(false);
         this.consultationData.dispBoardDetailsActive.push(false);
         this.consultationData.chosenDisps.push(this.consultationData.dispensary[i]);
      }

   }


   convertDiagnose(inData) {
      console.log('parse dx: ' + inData);
      if (inData != null) {
         let temp = JSON.parse(inData);
         this.consultationData.dxIdx = temp['idx'];
         this.consultationData.dxCustom = (temp['idx'] == -2) ? temp['val'] : '';
         return temp['val'];
      }

   }


   convertNotes(inData) {

      if (inData != null) {
         let temp = JSON.parse(inData);
         this.consultationData.noteCons = temp['cons'];
         this.consultationData.noteDisp = temp['disp'];
         this.consultationData.noteAcus = temp['acus'];
      }

   }


   packData() {
      // pack consultation data
      let symptomJson = JSON.stringify(this.consultationData.chosenSymptoms);
      let sympRemarkJson = JSON.stringify(this.consultationData.chosenSymptomsRemark);
      let symptoms = (this.consultationData.chosenSymptoms.length > 0 && this.consultationData.chosenSymptomsRemark.length > 0) ? {
         'data': symptomJson,
         'remark': sympRemarkJson
      } : { 'data': [], 'remark': [] };
      let sympJson = JSON.stringify(symptoms);

      // pack dispense data
      let dispJson = (this.consultationData.chosenDisps.length > 0) ? JSON.stringify(this.consultationData.chosenDisps) : JSON.stringify([]);

      // pack diagnose data
      let dx = (this.consultationData.dxIdx > -1) ? {
         'idx': this.consultationData.dxIdx,
         'val': this.data.diagnoses[this.consultationData.dxIdx]['name_en'] + ' - ' + this.data.diagnoses[this.consultationData.dxIdx]['name_zh']
      } : (this.consultationData.dxIdx == -1 || this.consultationData.dxIdx == -2) ? {
         'idx': this.consultationData.dxIdx,
         'val': (this.consultationData.dxIdx == -2) ? this.consultationData.dxCustom : ''
      } : { 'idx': -1, "val": "" };
      let dxJson = JSON.stringify(dx);

      // pack note dataObj
      let note = {
         'cons': this.consultationData.noteCons,
         'disp': this.consultationData.noteDisp,
         'acus': this.consultationData.noteAcus
      };
      let noteJson = JSON.stringify(note);


      // pack params and show loading indicator, and then upload to server
      let slBegin = (this.consultationData.slBegin != null) ? this.consultationData.slBegin : null;
      let slEnd = (this.consultationData.slEnd != null) ? this.consultationData.slEnd : null;
      let slRemark = (this.consultationData.slRemark != "") ? this.consultationData.slRemark : "";
      
      let params = {
         'token': this.data.token,
         'con_id': this.consultationData.consultation['con_id'],
         'con_symptoms': sympJson,
         'con_explain': (this.consultationData.consRemark != '') ? this.consultationData.consRemark : null,
         'con_dispensary': dispJson,
         'con_notes': noteJson,
         'con_dx': dxJson,
         'con_sl_begin': slBegin,
         'con_sl_end': slEnd,
         'con_sl_remark': slRemark
      };

      // if (this.consultationData.signCons) params['con_con_phy'] = this.consultationData.signCons[ 'phy_id' ];
      // if (this.consultationData.signDisp) params['con_disp_phy'] = this.consultationData.signDisp[ 'phy_id' ];
      // if (this.consultationData.signAcus) params['con_acu_phy'] = this.consultationData.signAcus[ 'phy_id' ];
      params['con_con_phy'] = this.consultationData.signCons[ 'phy_id' ] ? this.consultationData.signCons[ 'phy_id' ] : -1;
      params['con_disp_phy'] = this.consultationData.signDisp[ 'phy_id' ] ? this.consultationData.signDisp[ 'phy_id' ] : -1;
      params['con_acu_phy'] = this.consultationData.signAcus[ 'phy_id' ] ? this.consultationData.signAcus[ 'phy_id' ] : -1;

      return params;
   }


   getApiDate(inDate) {

      let dateStr = '';
      let monthStr = '' + (inDate.getMonth() + 1);
      if (monthStr.length == 1) monthStr = '0' + monthStr;
      let dayStr = '' + inDate.getDate();
      if (dayStr.length == 1) dayStr = '0' + dayStr;
      dateStr = inDate.getFullYear() + '-' + monthStr + '-' + dayStr;
      return dateStr;

   }

}



// WEBPACK FOOTER //
// ./src/providers/consultation-data-parser/consultation-data-parser.ts